import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
  linkTo,
  linkLabel,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 mb-8 md:mb-10 ${
        isCenter ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {kicker && (
          <p className="font-label text-xs tracking-[0.2em] text-primary-600 uppercase mb-2">
            {kicker}
          </p>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
        )}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1.5 text-sm font-label font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap shrink-0 cursor-pointer"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}